import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import SEO from '../components/SEO';
import { galleryData, galleryCategories } from '../data/galleryData';
import './Gallery.css';

const Gallery = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [filteredImages, setFilteredImages] = useState(galleryData);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  useEffect(() => {
    if (activeCategory === 'all') {
      setFilteredImages(galleryData);
    } else {
      setFilteredImages(galleryData.filter(item => item.category === activeCategory));
    }
  }, [activeCategory]);

  return (
    <>
      <SEO
        title="Gallery - SRI KRISH CIVIL SUPPLIER | Project Photos Coimbatore"
        description="View our completed projects gallery including building demolition, earthwork, and building materials supply in Coimbatore."
        keywords="construction gallery coimbatore, demolition projects, earthwork photos, building materials"
      />

      <div className="page-header gallery-header">
        <div className="container">
          <h1 data-aos="fade-up">Our Gallery</h1>
          <p data-aos="fade-up" data-aos-delay="100">Showcasing Our Excellence in Civil Construction</p>
        </div>
      </div>

      <section className="gallery-section">
        <div className="container">
          <div className="gallery-filters" data-aos="fade-up">
            {galleryCategories.map(category => (
              <button
                key={category.id}
                className={`filter-btn ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>

          <div className="gallery-grid">
            {filteredImages.map((item, index) => (
              <div key={item.id} className="gallery-item" data-aos="zoom-in" data-aos-delay={index * 50}>
                <img src={item.image} alt={item.title} />
                <div className="gallery-overlay">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Gallery;
